import { ReactElement } from 'react';
import { IconStackFront } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip } from '@rossum/ui/material';

type DatapointTooltipProps = {
  children: ReactElement;
  active: boolean;
  layerCount: number;
  label: string;
};

export const DatapointTooltip = ({
  children,
  active,
  layerCount,
  label,
}: DatapointTooltipProps) => (
  <Tooltip
    title={
      !active && layerCount > 1 ? (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <SvgIcon fontSize="medium">
            <IconStackFront />
          </SvgIcon>
          <span>{layerCount}</span>
        </Stack>
      ) : (
        ''
      )
    }
    arrow={false}
    disableInteractive
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 22],
          },
        },
      ],
    }}
  >
    <g>
      <Tooltip
        title={active ? '' : label}
        arrow={false}
        disableInteractive
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -6],
              },
            },
          ],
        }}
      >
        {children}
      </Tooltip>
    </g>
  </Tooltip>
);
